export const surveyStatuses = {
  1: 'Not started',
  2: 'In progress',
  3: 'Completed',
};
